/**
 * ------------------------------------------------------------------
 * BFF Error Classes
 * Shared error handling for BFF operations / observability
 * ------------------------------------------------------------------
 */
export enum BFFErrorEnum {
	BFF_ERROR = 'BFF_ERROR',
	BFF_NETWORK_ERROR = 'BFF_NETWORK_ERROR',
}

interface BFFErrorContext {
	additionalContext?: Record<string, any>;
	originalError?: Error | unknown;
	status: string;
}

interface BFFNetworkErrorContext extends BFFErrorContext {
	url: string;
}

/**
 * Base class for general failures
 */
export class BFFError extends Error {
	public readonly context?: BFFErrorContext['additionalContext'];
	public readonly originalError?: BFFErrorContext['originalError'];
	public readonly status: BFFErrorContext['status'];
	public readonly timestamp: string;

	constructor(message: string, context: BFFErrorContext) {
		super(message);

		this.name = BFFErrorEnum.BFF_ERROR;
		this.context = context.additionalContext;
		this.originalError = context.originalError;
		this.status = context.status;
		this.timestamp = new Date().toISOString();
	}
}

/**
 * Extended from BFFError specifically for fetch/network failures
 */
export class BFFNetworkError extends BFFError {
	public readonly url: string;

	constructor(message: string, context: BFFNetworkErrorContext) {
		super(message, context);

		this.name = BFFErrorEnum.BFF_NETWORK_ERROR;
		this.url = context.url;
	}
}
